import React, {useState}  from 'react';

import Slot from './carouselSlot'

const Carousel = ({data})  => {
    

    const [current, setCurrent] = useState(0);
    const [boolAuto, setBoolAuto] = useState(true);
    const length = data.length; 

    const nextSlot = () => {
        //                                   //Al cambiar data, current puede tener un valor mayor a la nueva long. 
        setCurrent((current === length - 1) || (current > length -1) ? 0 : current + 1);
    };
    
    const prevSlot = () => {
        setCurrent(current === 0 ? length - 1 : current - 1);
    };

    const handleTabClick = (index) => {
        setBoolAuto(false);
        clearTimeout(autoscroll);
        setCurrent(index);
    }
    
    var autoscroll = boolAuto ? setTimeout(() => {
        nextSlot();        
    }, 5000) : null ;

    if (!Array.isArray(data) || data.length <= 0) {
        return null;
    }

    return (
        <article>
            <div className="inner">
                {data.map((slot, index) => {
                    //console.log(slot.name, "indice :::", index, 'current :::', current, 'length :::' , length)
                    return (
                        <div className={current === index ? "ancho100 homeMain-banner" : null} key={index}>
                            {index === current && (
                            <Slot image={slot.image_banner} title={slot.name} text={slot.slogan}  link = {slot.link} tooltipText = {slot.slogan}/>
                            )}
                        </div>
                    )
                })}
            </div>
            <div className="tabs">
                {
                    data.map((slot,index) => {
                        return <span key={index} className={current === index ? "tab active" : "tab"} onClick={() => handleTabClick(index)}></span>  
                    })
                }
            </div>
            {/*length > 1 ? <div className="next" onClick={() => nextSlot()}>prev</div> : null}
            {length > 1 ? <div className="prev" onClick={() => prevSlot()}>next</div> : null*/}
        </article>);
};
export default Carousel;